import { gql } from '@apollo/client';

export const CONFIRM_EMAIL_MUTATION = gql`
  mutation ConfirmEmail($code: String!) {
    emailConfirmation(confirmation: $code) {
      jwt
      user {
        id
      }
    }
  }
`;
